var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/proms_welcome.c741b409.png","uri@2x": __webpack_public_path__ + "static/media/proms_welcome.38710071.png","uri@3x": __webpack_public_path__ + "static/media/proms_welcome.7ddb946b.png",
    width: 221,
    height: 221
});